import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { fetchStages, setOwner, setStage } from 'store/slices/dealsSlice';
import Details from './Details';
import Header from './Header';
import { muiStyles } from './muiStyles';

const DealDetailsMain = () => {
  const dispatch = useAppDispatch();
  const { pipelineType, stageName, owner } = useAppSelector((state) => state.deals.deal);

  useEffect(() => {
    const fetchOwners = async () => {
      try {
        await dispatch(fetchStages(pipelineType));
      } catch (error) {
        console.error(error);
      }
    };

    fetchOwners();
  }, [dispatch, pipelineType]);

  useEffect(() => {
    if (stageName) dispatch(setStage(stageName));
    if (owner) dispatch(setOwner(owner));
  }, [dispatch, stageName, owner]);

  return (
    <Box sx={muiStyles.root}>
      <Header />
      <Details />
    </Box>
  );
};

export default DealDetailsMain;
